<template>
  <div class="box">
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
      style="padding:20px;"
    >
      <el-tab-pane label="统计量录入" name="first">
        <el-form
          ref="form"
          :model="form"
          label-width="120px"
          style="margin-top:4px;margin-left: -25px;text-align: left;"
          size="small"
          class="form1"
        >
          <el-button
            size="small"
            type="primary"
            style="margin-left:30px;margin-bottom:10px"
            @click="openDiolog"
            >选择测量点</el-button
          >
          <el-form-item label="测量点ID">
            <p
              :style="
                form.measureId == '请选择测量点'
                  ? 'color:#b7adad'
                  : 'color:#111'
              "
            >
              {{ form.measureId }}
            </p>
          </el-form-item>
          <el-form-item label="测量点名称">
            <p
              :style="
                form.measureId == '请选择测量点'
                  ? 'color:#b7adad'
                  : 'color:#111'
              "
            >
              {{ form.measureName }}
            </p>
          </el-form-item>
          <el-form-item label="是否强制写入">
            <el-select
              v-model="form.froce"
              placeholder="请选择"
              style="width:300px;"
            >
              <el-option
                v-for="item in froceData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="测量点编码">
            <el-select
              v-model="form.pointCode"
              placeholder="请选择"
              style="width:300px;"
              v-if="this.showpointcode"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="测量点编号">
            <el-input
              class="input1"
              v-model="form.pointNumber"
              placeholder="请输入内容"
              style="width:300px"
            ></el-input>
          </el-form-item>
          <el-form-item label="时间粒度">
            <el-select
              v-model="form.grading"
              placeholder="请选择"
              style="width:300px"
            >
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker
              v-model="form.time"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy/MM/dd HH:mm:ss"
              :picker-options="pickerOptions"
              :unlink-panels="true"
              style
            ></el-date-picker>
            <el-button
              :disabled="
                this.form.measureId == '' ||
                this.form.measureId == '请选择测量点'
                  ? true
                  : false
              "
              size="small"
              type="primary"
              style="margin-left:30px"
              @click="gettime"
              >确定</el-button
            >
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData"
          style="margin-left:30px;width: 100%;margin-top:15px;"
          height="280"
          border
          :header-cell-style="tableHeaderColor"
        >
          <el-table-column
            prop="time"
            label="日期"
            width="250"
          ></el-table-column>
          <el-table-column prop="value" label="值">
            <template v-slot="scope">
              <el-input
                oninput="value=value.replace(/[^\d^\.]/g,'')"
                size="small"
                v-model="scope.row.value"
                placeholder="请输入内容"
                :ref="scope.$index"
                @keyup.enter.native="
                  enterchanger(scope.$index, scope.row, $event)
                "
                @change="handleEdit(scope.$index, scope.row)"
              ></el-input>
              <!-- v-enter-number -->
            </template>
          </el-table-column>
        </el-table>
        <el-button type="primary" @click="updata" class="updatabuttom"
          >保存</el-button
        >
      </el-tab-pane>
      <el-tab-pane label="表读数录入" name="second">
        <el-form
          ref="form"
          :model="form1"
          label-width="120px"
          style="margin-top:4px;margin-left: -25px;text-align: left;"
          size="small"
          class="form2"
        >
          <el-button
            size="small"
            type="primary"
            style="margin-left:30px;margin-bottom:10px"
            @click="openDiolog"
            >选择测量点</el-button
          >
          <el-form-item label="测量点ID">
            <p
              :style="
                form1.measureId == '请选择测量点'
                  ? 'color:#b7adad'
                  : 'color:#111'
              "
            >
              {{ form1.measureId }}
            </p>
          </el-form-item>
          <el-form-item label="测量点名称">
            <p
              :style="
                form1.measureId == '请选择测量点'
                  ? 'color:#b7adad'
                  : 'color:#111'
              "
            >
              {{ form1.measureName }}
            </p>
          </el-form-item>
          <el-form-item label="是否强制写入">
            <el-select
              v-model="form1.froce"
              placeholder="请选择"
              style="width:300px;"
            >
              <el-option
                v-for="item in froceData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="测量点编码">
            <el-select
              v-model="form1.pointCode"
              placeholder="请选择"
              style="width:300px"
              v-if="this.showpointcode1"
            >
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="测量点编号">
            <el-input
              v-model="form1.pointNumber"
              placeholder="请输入内容"
              style="width:300px"
            ></el-input>
          </el-form-item>
          <el-form-item label="时间粒度">
            <el-select
              v-model="form1.grading"
              placeholder="请选择"
              style="width:300px"
            >
              <el-option
                v-for="item in options4"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker
              v-model="form1.time"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy/MM/dd HH:mm:ss"
              :picker-options="pickerOptions"
              :unlink-panels="true"
            ></el-date-picker>
            <el-button
              :disabled="
                this.form1.measureId == '' ||
                this.form1.measureId == '请选择测量点'
                  ? true
                  : false
              "
              size="small"
              type="primary"
              style="margin-left:30px"
              @click="gettime"
              >确定</el-button
            >
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData1"
          style="margin-left:30px;width: 100%;margin-top:15px;"
          height="280"
          border
          :header-cell-style="tableHeaderColor"
        >
          <el-table-column prop="time" label="日期" width="250">
            <template v-slot="scope">
              <el-date-picker
                value-format="yyyy/MM/dd HH:mm:ss"
                v-model="scope.row.time"
                type="datetime"
                placeholder="选择日期时间"
              ></el-date-picker>
              <!-- <el-input v-model="scope.row.time"></el-input> -->
            </template>
          </el-table-column>
          <el-table-column prop="value" label="值">
            <template v-slot="scope">
              <el-input
                oninput="value=value.replace(/[^\d^\.]/g,'')"
                size="small"
                v-model="scope.row.value"
                placeholder="请输入内容"
                :ref="scope.$index"
                @keyup.enter.native="
                  enterchanger(scope.$index, scope.row, $event)
                "
                @change="handleEdit(scope.$index, scope.row)"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="primary" @click="updata" class="updatabuttom"
          >保存</el-button
        >
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="选择计量点"
      :visible.sync="open"
      width="900px"
      :destroy-on-close="true"
    >
      <diolog
        v-if="open"
        :viewtab="viewtab"
        @clicktable="gettablevalue"
      ></diolog>
      <div slot="footer" class="dialog-footer" style="margin-right:350px">
        <el-button type="primary" @click="okselect" class="btn"
          >确 定</el-button
        >
        <el-button @click="open = false" class="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dateTool from "@/utils/dateTool";
import * as utils from "@/utils/index.js";
import handleData from "@/utils/handleData.js";
import { isNull, isUndefined } from "util";
import * as fpg from "@/utils/fpg.js";
import diolog from "@/components/common/diolog.vue";
export default {
  components: {
    diolog,
  },

  data() {
    return {
      viewtab: {
        all: true,
        framework: true,
        view: true,
        class: true,
      },
      open: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      activeName: "first",
      showpointcode: true,
      showpointcode1: false,
      tablevalue: {},
      tablevalue1: {},
      form: {
        measureId: "请选择测量点",
        measureName: "请选择测量点",
        pointCode: "",
        pointNumber: "0",
        grading: "",
        time: [],
        endtime: "",
        froce: 1,
      },
      form1: {
        measureId: "请选择测量点",
        measureName: "请选择测量点",
        pointCode: "",
        pointNumber: "0",
        grading: "",
        time: [],
        endtime: "",
        froce: 1,
      },
      options: [
        {
          value: "100229",
          label: "正向有功总电能",
        },
        {
          value: "100230",
          label: "反向有功总电能",
        },
        {
          value: "100231",
          label: "正向无功总电能（组合无功1）",
        },
        {
          value: "100232",
          label: "反向无功总电能（组合无功2）",
        },
        {
          value: "100401",
          label: "总正向流量（累计流量）",
        },
        {
          value: "100402",
          label: "反正向流量（统计量）",
        },
        {
          value: "100701",
          label: "计数（统计量）",
        },
      ],
      options3: [
        {
          value: "229",
          label: "正向有功总电能",
        },
        {
          value: "230",
          label: "反向有功总电能",
        },
        {
          value: "231",
          label: "正向无功总电能（组合无功1）",
        },
        {
          value: "232",
          label: "反向无功总电能（组合无功2）",
        },
        {
          value: "401",
          label: "总正向流量（累计流量）",
        },
        {
          value: "402",
          label: "反正向流量（统计量）",
        },
        {
          value: "701",
          label: "计数",
        },
      ],
      options1: [
        {
          value: "hour",
          label: "时",
        },
        {
          value: "day",
          label: "日",
        },
        {
          value: "month",
          label: "月",
        },
        {
          value: "year",
          label: "年",
        },
      ],
      options4: [
        {
          value: "hour",
          label: "时",
        },
        // {
        //   value: "day",
        //   label: "日"
        // },
        // {
        //   value: "month",
        //   label: "月"
        // },
        // {
        //   value: "year",
        //   label: "年"
        // }
      ],
      tableData: [],
      tableData1: [],
      froceData: [
        {
          id: 0,
          name: "否",
        },
        {
          id: 1,
          name: "是",
        },
      ],
    };
  },
  methods: {
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      //改表头颜色
      if (rowIndex === 0) {
        return "background-color: #F3F3F3;color: #666;";
      }
    },
    //tab栏切换时间
    handleClick() {
      if (this.activeName == "second") {
        // this.form = {
        //   measureId: "",
        //   measureName: "",
        //   pointCode: "",
        //   pointNumber: "0",
        //   grading: "",
        //   time: [],
        //   endtime: ""
        // };
        // this.tableData = [];
        this.showpointcode = false;
        this.showpointcode1 = true;
      } else {
        // this.form = {
        //   measureId: "",
        //   measureName: "",
        //   pointCode: "",
        //   pointNumber: "0",
        //   grading: "",
        //   time: [],
        //   endtime: ""
        // };
        // this.tableData = [];
        this.showpointcode = true;
        this.showpointcode1 = false;
      }
    },
    //打开选择测量点弹框
    openDiolog() {
      if (this.open == true) {
        this.open = false;
      } else {
        this.open = true;
      }
    },
    //生产时间段表格
    gettime() {
      if (this.activeName == "first") {
        if (
          this.form.grading == "" ||
          this.form.time == [] ||
          this.form.time == null ||
          this.form.time.length == 0
        ) {
          alert("请选择时间粒度和日期");
          return;
        }

        var date1 = new Date(this.form.time[0]); //开始时间
        var date2 = new Date(this.form.time[1]); //结束时间
        var date3 = date2 - date1; //时间差的毫秒数
        if (this.form.grading == "hour") {
          let leave1 = Math.floor(date3 / (3600 * 1000)); //计算天数后剩余的毫秒数
          // var hours = Math.floor(leave1 / (3600 * 1000));
          let data = [];
          let date4 = fpg.getMatchTime1(
            this.form.time[0],
            this.form.time[1],
            "0"
          );
          this.tableData = date4;
        } else if (this.form.grading == "day") {
          let days = Math.floor(date3 / (24 * 3600 * 1000));
          let date4 = handleData.createXData(
            "3",
            this.form.time[0],
            this.form.time[1],
            true
          );
          this.tableData = date4;
        } else if (this.form.grading == "month") {
          let days = Math.floor((date3 / (24 * 3600 * 1000)) * 30);
          if (days >= 900) {
            let date4 = handleData.createXData(
              "5",
              this.form.time[0],
              this.form.time[1],
              true
            );
            let hash = {};
            const data2 = date4.reduce((preVal, curVal) => {
              hash[curVal.time]
                ? ""
                : (hash[curVal.time] = true && preVal.push(curVal));
              return preVal;
            }, []);
            this.tableData = data2;
          } else {
            let date4 = dateTool.format(new Date(this.form.time[0]), "yyyy-MM");
            let data4 = [
              {
                time: date4,
                value: "",
              },
            ];
            this.tableData = data4;
          }
        } else if (this.form.grading == "year") {
          let days = Math.floor((date3 / (24 * 3600 * 1000)) * 30);
          let date4 = dateTool.format(new Date(this.form.time[0]), "yyyy");
          let date5 = dateTool.format(new Date(this.form.time[1]), "yyyy");
          let data4 = [];
          if (date4 != date5) {
            for (let i = date4; i <= date5; i++) {
              data4.push({
                time: i,
                value: "",
              });
            }
            this.tableData = data4;
          } else {
            let data4 = [
              {
                time: date4,
                value: "",
              },
            ];
            this.tableData = data4;
          }
        }
      } else {
        if (
          this.form1.grading == "" ||
          this.form1.time == [] ||
          this.form1.time == null ||
          this.form1.time.length == 0
        ) {
          alert("请选择时间粒度和日期");
          return;
        }

        var date1 = new Date(this.form1.time[0]); //开始时间
        var date2 = new Date(this.form1.time[1]); //结束时间
        var date3 = date2 - date1; //时间差的毫秒数
        if (this.form1.grading == "hour") {
          let leave1 = Math.floor(date3 / (3600 * 1000)); //计算天数后剩余的毫秒数
          // var hours = Math.floor(leave1 / (3600 * 1000));
          let data = [];
          let date4 = fpg.getMatchTime1(
            this.form1.time[0],
            this.form1.time[1],
            "1"
          );
          this.tableData1 = date4;
        } else if (this.form1.grading == "day") {
          let days = Math.floor(date3 / (24 * 3600 * 1000));
          let date4 = handleData.createXData(
            "3",
            this.form1.time[0],
            this.form1.time[1],
            true
          );
          this.tableData1 = date4;
        } else if (this.form1.grading == "month") {
          let days = Math.floor((date3 / (24 * 3600 * 1000)) * 30);
          if (days >= 900) {
            let date4 = handleData.createXData(
              "5",
              this.form1.time[0],
              this.form1.time[1],
              true
            );
            let hash = {};
            const data2 = date4.reduce((preVal, curVal) => {
              hash[curVal.time]
                ? ""
                : (hash[curVal.time] = true && preVal.push(curVal));
              return preVal;
            }, []);
            this.tableData1 = data2;
          } else {
            let date4 = dateTool.format(
              new Date(this.form1.time[0]),
              "yyyy-MM"
            );
            let data4 = [
              {
                time: date4,
                value: "",
              },
            ];
            this.tableData1 = data4;
          }
        } else if (this.form1.grading == "year") {
          let days = Math.floor((date3 / (24 * 3600 * 1000)) * 30);
          let date4 = dateTool.format(new Date(this.form1.time[0]), "yyyy");
          let date5 = dateTool.format(new Date(this.form1.time[1]), "yyyy");
          let data4 = [];
          if (date4 != date5) {
            for (let i = date4; i <= date5; i++) {
              data4.push({
                time: i,
                value: "",
              });
            }
            this.tableData1 = data4;
          } else {
            let data4 = [
              {
                time: date4,
                value: "",
              },
            ];
            this.tableData1 = data4;
          }
        }
      }
    },
    handleEdit(index, row) {},
    enterchanger(index, row, e) {
      // console.log(index, row, e);
      if (this.activeName == "first") {
        e.target.blur();
        // // TODO  需要对最后一个input做判断
        if (index + 1 == this.tableData.length) {
          return;
        } else {
          // this.$refs[Object.keys(this.$refs)[index + 1]].focus();
          this.$refs[index + 1].focus();
        }
      } else {
        // console.log(index + 1);
        // console.log(this.tableData1.length);
        // console.log(index + 1 == this.tableData1.length);
        // e.target.blur();
        // console.log(this.$refs[index]);
        // // // TODO  需要对最后一个input做判断
        // if (index + 1 == this.tableData1.length) {
        //   return;
        // } else {
        //   // this.$refs[Object.keys(this.$refs)[index + 1]].focus();
        //   this.$refs[index + 1].focus();
        // }
      }
    },
    gettablevalue(val) {
      if (this.activeName == "first") {
        this.tablevalue.measureId = val.id;
        this.tablevalue.measureName = val.name;
      } else {
        this.tablevalue1.measureId = val.id;
        this.tablevalue1.measureName = val.name;
      }
    },
    okselect() {
      if (this.activeName == "first") {
        if (JSON.stringify(this.tablevalue) == "{}") {
          this.$message({
            message: "请选择测量点！",
            type: "warning",
          });
          return;
        } else {
          this.form.measureId = this.tablevalue.measureId;
          this.form.measureName = this.tablevalue.measureName;
          this.open = false;
          setTimeout(() => {
            this.tablevalue = {};
          }, 10);
        }
      } else {
        if (JSON.stringify(this.tablevalue1) == "{}") {
          this.$message({
            message: "请选择测量点！",
            type: "warning",
          });
          return;
        } else {
          this.form1.measureId = this.tablevalue1.measureId;
          this.form1.measureName = this.tablevalue1.measureName;
          this.open = false;
          setTimeout(() => {
            this.tablevalue1 = {};
          }, 10);
        }
      }
    },
    updata() {
      if (this.activeName == "first") {
        let values = [];
        this.tableData.map((item) => {
          let value = item.value == "" ? null : parseFloat(item.value);
          values.push(value);
        });
        if (
          this.form.measureId == "" ||
          this.form.measureName == "" ||
          this.form.pointCode == "" ||
          this.form.pointNumber == "" ||
          this.tableData.length == 0 ||
          this.form.froce === ""
        ) {
          this.$message({
            message: "数据不能为空！",
            type: "warning",
          });
          return;
        }
        this.$confirm("此操作将永久覆盖数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            if (this.form.grading == "hour") {
              this.$api.entering
                .setQuantitiesHour(
                  this.form.measureId,
                  this.form.pointCode,
                  this.form.pointNumber,
                  "",
                  this.form.time[0],
                  values,
                  this.form.froce
                )
                .then((res) => {
                  if (res.success == true) {
                    this.$message({
                      message: res.msg,
                      type: "success",
                    });
                  } else {
                    this.$message({
                      message: res.msg,
                      type: "warning",
                    });
                    return;
                  }
                });
            } else if (this.form.grading == "day") {
              this.$api.entering
                .setQuantitiesDay(
                  this.form.measureId,
                  this.form.pointCode,
                  this.form.pointNumber,
                  "",
                  this.form.time[0],
                  values,
                  this.form.froce
                )
                .then((res) => {
                  if (res.success == true) {
                    this.$message({
                      message: res.msg,
                      type: "success",
                    });
                  } else {
                    this.$message({
                      message: res.msg,
                      type: "warning",
                    });
                    return;
                  }
                });
            } else if (this.form.grading == "month") {
              this.$api.entering
                .setQuantitiesMonth(
                  this.form.measureId,
                  this.form.pointCode,
                  this.form.pointNumber,
                  "",
                  this.form.time[0],
                  values,
                  this.form.froce
                )
                .then((res) => {
                  if (res.success == true) {
                    this.$message({
                      message: res.msg,
                      type: "success",
                    });
                  } else {
                    this.$message({
                      message: res.msg,
                      type: "warning",
                    });
                    return;
                  }
                });
            } else if (this.form.grading == "year") {
              this.$api.entering
                .setQuantitiesYear(
                  this.form.measureId,
                  this.form.pointCode,
                  this.form.pointNumber,
                  "",
                  this.form.time[0],
                  values
                  //   this.form.froce
                )
                .then((res) => {
                  if (res.success == true) {
                    this.$message({
                      message: res.msg,
                      type: "success",
                    });
                  } else {
                    this.$message({
                      message: res.msg,
                      type: "warning",
                    });
                    return;
                  }
                });
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消修改",
            });
          });
      } else {
        if (
          this.form1.measureId == "" ||
          this.form1.measureName == "" ||
          this.form1.pointCode == "" ||
          this.form1.pointNumber == "" ||
          this.tableData1.length == 0
        ) {
          this.$message({
            message: "数据不能为空！",
            type: "warning",
          });
          return;
        }
        this.$confirm("此操作将永久覆盖数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$api.entering
              .setMeasuringRawValueForCount(
                this.form1.measureId,
                this.form1.pointCode,
                this.form1.pointNumber,
                this.tableData1,
                this.form1.froce
              )
              .then((res) => {
                if (res.success == true) {
                  this.$message({
                    message: res.errorStr,
                    type: "success",
                  });
                } else {
                  this.$message({
                    message: res.errorStr,
                    type: "warning",
                  });
                  return;
                }
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消修改",
            });
          });
      }
    },
    formatterdata(e) {
      if (e.value == "") {
        return null;
      } else {
        return e.value;
      }
    },
  },
};
</script>
<style scoped>
#pane-first >>> .el-form-item,
#pane-second >>> .el-form-item {
  display: flex;
  align-items: center;
}
</style>
<style scoped lang="scss">
.updatabuttom {
  margin-top: 10px;
  margin-left: 180px;
  width: 200px;
}
</style>
